module.exports = __webpack_public_path__ + "static/media/snake.284ad000.ogg";